import Cookies from 'js-cookie';
import React, { memo, useCallback, useEffect, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { useCustomer } from 'common/hooks';
import { postRemarketing } from 'common/redux/user/api';

import { mapRemarketingToServer, parseParams } from './helpers';

const AnalyticsProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { search, pathname } = useLocation();
  const { isAuthenticated } = useCustomer();
  const history = useHistory();
  const cookie = useMemo(() => Cookies.get('Remarketings'), []);

  const paramsFromUrl = useMemo(() => parseParams(search), [search]);
  const paramsFromCookies = useMemo(() => parseParams(cookie), [cookie]);

  const remarketing = useMemo(
    () => mapRemarketingToServer(paramsFromUrl || paramsFromCookies),
    [paramsFromCookies, paramsFromUrl],
  );

  const onPostRemarketinParams = useCallback(() => {
    if (paramsFromCookies) Cookies.remove('Remarketings');
  }, [paramsFromCookies]);

  useEffect(() => {
    if (paramsFromUrl) history.replace(pathname);
  }, [paramsFromUrl, pathname, history]);

  useEffect(() => {
    if (isAuthenticated && remarketing.length) {
      postRemarketing(remarketing).finally(onPostRemarketinParams);
    }
  }, [isAuthenticated, onPostRemarketinParams, remarketing]);

  return children;
};

export default memo(AnalyticsProvider);
